import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, onMounted, nextTick } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  useSelectColumn,
  BaseButton,
  BaseDialog,
  BaseTextContent,
  useInputColumn,
  XrkMessage
} from 'xrk-components';
import { formatter } from '@/utils';
import { C_PAYMENT_METHOD } from '@constants/bank';
import { notInvoicedListUserInfo } from '@V/invoice/src/data-source/apis';
import { C_INVOICE_STATUS } from '@V/invoice/src/constants';
import { NotInvoicedListUserInfoItem } from '@V/invoice/src/data-source/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-wtdk-2-dialog',
  props: {
    remove: {},
    selections: { default() {
      return [];
    } },
    userDefinedOrderId: {}
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

const xrkTableRef = ref();

const selections = computed(() => {
  return xrkTableRef.value?.getSelectionRows?.() || [];
});

const getListAjax = async params => {
  const resp = await notInvoicedListUserInfo({
    ...params,
    userDefinedOrderId: props.userDefinedOrderId
  });
  return resp;
};

const onConfirm = () => {
  if (!selections.value.length) {
    XrkMessage.error('请选择开票人');
    return;
  }
  emits('success', selections.value);
  props.remove();
};

onMounted(() => {
  nextTick(() => {
    props.selections.forEach(item => {
      xrkTableRef.value?.addSelectionRow?.(item.openOrderId, item);
    });
  });
});

const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchColumns: [
    useInputColumn({
      prop: 'name',
      label: '项目参与人',
      config: {
        type: 'text',
        placeholder: '请输入'
      }
    }),
    useSelectColumn({
      prop: 'invoiceStatus',
      label: '开票状态',
      config: {
        placeholder: '请选择',
        options: C_INVOICE_STATUS
      }
    })
  ],
  searchBtn: {
    show: true,
    text: '搜索',
    beforeSearch() {
      xrkTableRef.value.initList();
      return Promise.reject();
    }
  },
  resetBtn: {
    show: false,
    text: '重置'
  }
});

const tableConfig = ref<XrkTableProps['tableConfig']>({
  baseConfig: { rowKey: 'openOrderId' },
  tableColumns: [
    useTableColumn({
      type: '_selection',
      prop: 'openOrderId',
      align: 'center',
      fixed: 'left',
      width: 110,
      selectionDisabled: (row: any) =>
        // 未开票且支付完成才可操作
        !(row.invoiceStatus == 0 && [2, 4].includes(row.newPayStatus))
    }),
    useTableColumn({
      type: 'index',
      label: '序号',
      width: '80px'
    }),
    useTableColumn({
      label: '项目参与人姓名',
      prop: 'name',
      width: '140px'
    }),
    useTableColumn({
      label: '手机号',
      prop: 'phone'
    }),
    useTableColumn({
      label: '收款方式',
      prop: 'collectMoneyType',
      formatter: ({ cellValue }) =>
        formatter.defaultFormat(
          cellValue,
          () => C_PAYMENT_METHOD[cellValue].label
        )
    }),
    useTableColumn({
      label: '收款账号',
      prop: 'bfAccount'
    }),
    useTableColumn({
      label: '终端结算金额(元)',
      prop: 'userDefinedPrice',
      width: '160px',
      formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
    }),
    useTableColumn({
      label: '开票状态',
      prop: 'invoiceStatus',
      width: '140px',
      formatter: ({ cellValue }) =>
        formatter.defaultFormat(
          cellValue,
          () => C_INVOICE_STATUS[cellValue].label
        )
    })
  ]
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "950px",
    class: "form-dialog form-dialog--label120",
    title: "选择开票人",
    "model-value": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: _ctx.remove
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_unref(BaseButton), { onClick: onConfirm }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(XrkTable), {
            ref_key: "xrkTableRef",
            ref: xrkTableRef,
            getListAjax: getListAjax,
            searchConfig: searchConfig.value,
            tableConfig: tableConfig.value
          }, null, 8, ["searchConfig", "tableConfig"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})